import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { authActions } from '../actions/auth.actions';
import { selectError, selectLoggedIn } from '../selectors/auth.selector';

@Service()
export class AuthFacade {
    private readonly store = inject(Store);

    readonly loggedIn = this.store.selectSignal(selectLoggedIn);
    readonly error = this.store.selectSignal(selectError);

    readonly loggedIn$ = this.store.select(selectLoggedIn);
    readonly error$ = this.store.select(selectError);

    loginWithPin(pin: string): void {
        this.store.dispatch(authActions.loginWithPin({ pin }));
    }

    clear(): void {
        this.store.dispatch(authActions.clear());
    }
}
